import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 6a8 3 0 1 0 16 0a8 3 0 1 0 -16 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 6v6a8 3 0 0 0 16 0v-6" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 12v6a8 3 0 0 0 16 0v-6" })
	]
});
export { SvgDatabase as ReactComponent };
